
<div class="row">
<div class="col-sm-3">
  <app-side-bar-guardian-home
        [guardian]="guardian"
        [target_student_user_id]="studentDetail['server_user_id']"
        ></app-side-bar-guardian-home>
</div>
<div *ngIf="studentDetail && guardian" class="col-sm-8">
<div class="card">
    <h6 class="card-header text-center">Enrollments for {{studentDetail.fullname}}</h6>
    <div class="card-body">
        <table class="table table-sm table-borderless table-striped" *ngIf="enrollments.length>0">
            <thead>
                <tr>
                    <th>Id</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Level</th>
                    <th>Valid</th>
                    <th>Subjects</th>
                    <th>Premium </th>
                </tr>
            </thead>
            <tbody>
             <tr *ngFor="let enrolment of enrollments;">
                 <td>{{enrolment.server_enrolment_id}}</td>
                 <td>{{enrolment.startDate}}</td>
                 <td>{{enrolment.endDate}}</td>
                 <td >{{enrolment.level_short_name}}</td>
                 <td class="text-center">{{enrolment.is_valid? 'Yes' : 'No'}}</td>
                 <td>
                    <div class="subscription-tree">
                        <ul>
                           <li *ngFor="let subscription of enrolment.subscriptions; index as myCount2">{{subscription.name}}
                               <ul *ngIf="(enrolment.is_valid)">
                                   <li *ngIf="enrolment.is_current">
                                   <a [routerLink]="['student/quiz/new',studentDetail.server_user_id,subscription.server_subscription_id]"><i class="fa fa-plus"></i>  New Quiz</a>
                                   </li>
                                   <li *ngIf="enrolment.is_current">
                                       <a [routerLink]="['/area/quiz/modify']"><i class="fa fa-edit"></i> Quiz Area</a>
                                   </li>
                               </ul>
                           </li>
                       </ul>
                   </div>
                 </td>
                 <td>
                    <span class="me-2">{{enrolment.is_premium?'Yes':'No'}}</span>
                    <span *ngIf="(enrolment.server_enrolment_id == current_server_enrolment_id)">
                        <span *ngIf="!enrolment.is_premium">
                            <button  (click)="addUpgradeEnrolmentPopup()" class="btn btn-outline-primary me-2">
                              <span *ngIf="enrolLoading" class="spinner-border spinner-border-sm me-1"></span>
                              Upgrade</button>

                            <button *ngIf="!enrolment.is_premium && gatePass.is_role_admin" [disabled]="adminUpgrading" (click)="adminUpgradeEnrolment(enrolment.server_enrolment_id)" class="btn btn-outline-primary ml-2">
                                <span *ngIf="adminUpgrading" class="spinner-border spinner-border-sm ms-1"></span>
                                Admin Upgrade</button>
                        </span>
                        <span *ngIf="enrolment.is_premium && ! enrolment.is_valid">
                            <button  (click)="addUpgradeEnrolmentPopup()" class="btn btn-outline-primary me-2">Extend</button>
                        </span>
                        <span *ngIf="admin_extend">
                            <button [disabled]="adminExtending" (click)="adminExtendEnrolmentModalShow(enrolment.server_enrolment_id)" class="btn btn-outline-primary ml-2">
                                <span *ngIf="adminExtending" class="spinner-border spinner-border-sm me-1"></span>
                                Admin Extend </button>
                            <app-enrol-admin-extend *ngIf="(studentDetail.is_premium_ready==1)" [student]="student" [enrolment]="enrolment" [guardian]="guardian"></app-enrol-admin-extend>
                        </span>
                    </span>
                 </td>
            </tr>
        </tbody>
        </table>
        <div class="alert alert-info text-center" *ngIf="enrollments.length==0">
            No Enrollments Found
        </div>
        <fieldset class="buttons text-center">


            <button  *ngIf="(add_trial || add_trial_admin)"
            class="btn btn-outline-primary me-5"
            (click)="addTrialEnrolmentPopup()" >
            <span *ngIf="enrolTrialLoading" class="spinner-border spinner-border-sm me-1"></span>
                <i class="fa fa-plus"></i>
                 Add Enrolment
            </button>


        </fieldset>
   </div>
</div>


<app-enrol-trial *ngIf="(add_trial || add_trial_admin)"
[studentDetail]="studentDetail"
[guardian]="guardian"
(provisioning)="alertProvisioning($event)"
(enrolLoading)="toggleTrialEnrolLoading($event)"
(closeModalRequest)="closeModal($event)"></app-enrol-trial>

<app-enrol-upgrade *ngIf="current_server_enrolment_id!=0 && guardian"
[studentDetail]="studentDetail"
[guardian]="guardian"
(enrolLoading)="toggleEnrolLoading($event)"
(closeModalRequest)="closeModal($event)"></app-enrol-upgrade>

<app-enrol-admin-extend *ngIf="admin_extend"
[studentDetail]="studentDetail"
[guardian]="guardian"
[enrolment_extend_id]="enrolment_extend_id"
(enrolLoading)="toggleEnrolLoading($event)"
(closeModalRequest)="closeModal($event)"></app-enrol-admin-extend>
</div>
</div>
<div class="row">
  <div class="col-sm-12"><app-spinner *ngIf="!studentDetail || !guardian"> </app-spinner></div>
</div>


